import { Theme } from "@mui/material/styles";
import {
    CHANNEL_COVER_ASPECT_RATIO,
    CHANNEL_COVER_BACKGROUND_STYLES,
} from "@Utils/channelCover";

const getSubChannelSelectionDialogSx = (theme: Theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        minHeight: "100dvh",
        backgroundColor: theme.palette.common.white,
    },
    hero: {
        position: "relative",
        width: "100%",
        minHeight: { xs: 260, sm: 300 },
        flexShrink: 0,
        overflow: "hidden",
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr)",
        alignItems: "end",
        justifyItems: "center",
        boxSizing: "border-box",
        // Let taller content expand the shared row beyond the cover ratio.
        "&::before": {
            content: '""',
            gridArea: "1 / 1",
            width: "100%",
            aspectRatio: `${CHANNEL_COVER_ASPECT_RATIO}`,
        },
    },
    heroOverlay: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        ...CHANNEL_COVER_BACKGROUND_STYLES,
    },
    heroContent: {
        position: "relative",
        gridArea: "1 / 1",
        zIndex: 1,
        textAlign: "center",
        color: theme.palette.common.white,
        maxWidth: {
            xs: `calc(720px + ${theme.spacing(4)})`,
            sm: `calc(720px + ${theme.spacing(6)})`,
        },
        width: "100%",
        boxSizing: "border-box",
        padding: { xs: theme.spacing(4, 2, 3), sm: theme.spacing(6, 3, 4) },
    },
    parentAvatar: {
        width: { xs: 72, sm: 96 },
        height: { xs: 72, sm: 96 },
        margin: "0 auto",
        border: "4px solid rgba(255,255,255,0.85)",
        boxShadow: "0 12px 24px rgba(0,0,0,0.25)",
    },
    heroTitle: {
        marginTop: { xs: theme.spacing(1.5), sm: theme.spacing(2.5) },
        fontWeight: 700,
        fontSize: { xs: "1.35rem", sm: "1.75rem" },
        textShadow: "0 6px 16px rgba(0,0,0,0.35)",
        overflowWrap: "anywhere",
    },
    heroSubtitle: {
        marginTop: theme.spacing(1),
        fontSize: { xs: "0.9rem", sm: "1rem" },
        lineHeight: 1.5,
        textShadow: "0 2px 12px rgba(0,0,0,0.3)",
        display: "-webkit-box",
        WebkitLineClamp: { xs: 3, sm: 4 },
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
    },
    content: {
        flex: "1 0 auto",
        width: "100%",
        boxSizing: "border-box",
        padding: { xs: theme.spacing(2, 2, 0), sm: theme.spacing(3, 3, 0) },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: theme.spacing(3),
    },
    contentInner: {
        width: "100%",
        maxWidth: 720,
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
    },
    heading: {
        fontWeight: 600,
        fontSize: ".8rem",
        color: theme.palette.text.primary,
        textAlign: "center",
        overflowWrap: "anywhere",
    },
    autocomplete: {
        marginTop: theme.spacing(1),
    },
    optionWrapper: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        minWidth: 0,
    },
    optionAvatar: {
        width: 56,
        height: 56,
    },
    optionTexts: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.5),
        overflow: "hidden",
    },
    optionTitle: {
        fontWeight: 600,
        fontSize: "1rem",
        color: theme.palette.text.primary,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    optionDescription: {
        fontSize: "0.9rem",
        color: theme.palette.text.secondary,
        lineHeight: 1.4,
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
    },
    continueButton: {
        width: "100%",
        maxWidth: 720,
        margin: theme.spacing(3, 0),
    },
});

export default getSubChannelSelectionDialogSx;
